import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SellerComponent } from './seller/seller.component';
import { SellerproductsComponent } from './sellerproducts/sellerproducts.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { MatBadgeModule } from '@angular/material/badge';
import {AppCommonModule} from "../common/common.module";



@NgModule({
  declarations: [
    SellerComponent,
    SellerproductsComponent
  ],
  imports: [
    CommonModule,
    ScrollingModule,
    NgbRatingModule,
    MatBadgeModule,
    AppCommonModule
  ]
})
export class SellerModule { }
